/* eslint no-unused-vars: 0 */
import { Canvas, TEvent, Circle as FabricCircle } from 'fabric';
import { FabricCanvasTool } from '../index';
import { linearDistance } from '../../../../utils';
import { SketchProperties, Tool } from '../../../../types';

// eslint-disable-next-line import/prefer-default-export
export class Circle extends FabricCanvasTool {
    private width?: number;

    private color?: string;

    private fill?: string;

    private startX: number;

    private startY: number;

    private isDown: boolean;

    private circle: FabricCircle | null;

    type(): Tool {
        return Tool.CIRCLE;
    }

    constructor(canvas: Canvas) {
        super(canvas);
        this.startX = 0;
        this.startY = 0;
        this.isDown = false;
        this.circle = null;
    }

    configureCanvas(props: SketchProperties) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        this.canvas.forEachObject(o => { o.selectable = false; o.evented = false; });
        this.width = props.lineWidth;
        this.color = props.lineColor;
        this.fill = props.fillColor;
    }

    doMouseDown(o: TEvent) {
        this.isDown = true;
        const pointer = this.canvas.getPointer(o.e);
        [this.startX, this.startY] = [pointer.x, pointer.y];
        this.circle = new FabricCircle({
            left: this.startX,
            top: this.startY,
            originX: 'left',
            originY: 'center',
            strokeWidth: this.width,
            stroke: this.color,
            fill: this.fill,
            selectable: false,
            evented: false,
            radius: 1,
        });
        this.canvas.add(this.circle);
    }

    doMouseMove(o) {
        if (!this.isDown) return;
        const pointer = this.canvas.getPointer(o.e);
        this.circle?.set({
            radius: linearDistance(
                { x: this.startX, y: this.startY },
                { x: pointer.x, y: pointer.y },
            ) / 2,
            angle: (Math.atan2(pointer.y - this.startY, pointer.x - this.startX) * 180) / Math.PI,
        });
        this.circle?.setCoords();
        this.canvas.renderAll();
    }

    doMouseUp(o) {
        this.isDown = false;
    }
}
